export class GetCdcSqlSetupCheckResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlSetupCheck",
            "baseName": "sqlSetupCheck",
            "type": "SqlSetupCheckResult",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetCdcSqlSetupCheckResponse.attributeTypeMap;
    }
    constructor() {
    }
}
